<template>
    <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
    <div class="basic-setting-content pl16 pr16">
        <!--基本信息-->
        <div class="common-form " style="display: flex;">
            <div>基本信息</div>
            <div style="margin-left: 20px;">
                <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加</el-button>
            </div>
        </div>
        <div>
            <el-table :data=" form.model.product_clock" border style="width: 100%">

                <el-table-column prop="productName" label="项目名称" width="120">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.productName" class="max-w460"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="productPrice" label="项目价格" width="120">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.productPrice" class="max-w460" type="number"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="imageId" label="项目图片" width="120">
                    <template slot-scope="scope">
                        <div class="item img-select" @click="openProductUpload(scope)" 
                            v-if="scope.row.imageId == 0">
                            <i class="el-icon-plus"></i>
                        </div>
                        <div v-if="scope.row.imageId != 0" class="item" @click="openProductUpload(scope)">
                            <img :src="scope.row.image.filePath" width="100" height="100" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="salesInitial" label="初始销量" width="300">
                     <template slot-scope="scope">
                        <el-input v-model="scope.row.salesInitial" class="max-w460" type="number"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="sales_actual" label="实际销量" width="120">
                     <template slot-scope="scope">
                        <el-input v-model="scope.row.sales_actual" class="max-w460" type="number"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceTime" label=" 服务时长(分钟)	" width="120">
                     <template slot-scope="scope">
                        <el-input v-model="scope.row.serviceTime" class="max-w460" type="number"></el-input>
                    </template>
                </el-table-column>

                <el-table-column prop="productSort" label=" 项目排序(数字越小越靠前)" >
                     <template slot-scope="scope">
                        <el-input v-model="scope.row.productSort" class="max-w460" type="number"></el-input>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" >
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div v-for="(item,index) in product_clock" :key="index" class="myborder" style="margin-bottom: 20px;padding-top: 20px;position: relative;">
        <div></div>
          <el-form-item label="项目名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.productName">
      <el-input v-model="item.productName" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目封面：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div class="draggable-list">

        <div class="item img-select" @click="openProductUpload('image', 'poster')" v-if="item.imageId == 0">
          <i class="el-icon-plus"></i>
        </div>
        <div v-if="item.imageId != 0" class="item" @click="openProductUpload('image', 'poster')">
          <img :src="item.image[0].filePath" width="100" height="100" />
        </div>
      </div>
      <div style="color:orange">注意：上传的尺寸比例为3:4最优</div>
    </el-form-item> 
    <el-form-item label="服务时长(分钟)：">
      <el-input v-model="item.serviceTime" class="max-w460" type="number" min="0"></el-input>
    </el-form-item>
    <el-form-item label="项目价格：" width="80" :rules="[{ required: true, message: '请填写项目价格' }]"
     >
      <el-input type="number" v-model="item.productPrice" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="虚拟销量" width="80"
      prop="model.salesInitial">
      <el-input type="number" v-model="item.salesInitial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.productSort">
      <el-input type="number" min="0" v-model="item.productSort" class="max-w460"></el-input>
    </el-form-item>
    </div> -->


        <!--商品图片组件-->
        <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
            上传图片
        </Upload>
    </div>
</template>

<script>
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
    components: {
        Upload,
        draggable
    },
    data() {
        return {
            isProductUpload: false,
            config: {},
            file_name: "image",
            inputVisible: false,
            inputValue: "",
            // product_clock: [],
            selectscope:{}
        };
    },
    inject: ["form"],
    created() {
        if(this.form.model.clockProduct){
            this.form.model.product_clock=this.form.model.clockProduct
        }
        console.log("===========form", this.form.model.clockProduct);
    //    this.form.model.product_clock=this.product_clock||[]

    },
    methods: {
        addClick() {
            this.form.model.product_clock.push({
                productName: '',
                imageId: 0,
                productPrice: '',
                serviceTime: '',
                salesInitial: '',
                productSort: 0,
                image:{
                filePath:''

                }
            })
        },
        handleClick(row) {
            // let index = this.product_clock.indexOf(row);
            this.form.model.product_clock.splice(row.$index, 1)
        },
        /*打开上传图片*/
        openProductUpload(e1) {
            // console.log(e1.$index)
            this.selectscope=e1.$index
                this.config = {
                    total: 1,
                    fileType: "image"
                };
        
            this.isProductUpload = true;
        },

        /*上传商品图片*/
        returnProductImgsFunc(e) {
          
            if (e != null) {
                   this.form.model.product_clock[this.selectscope].imageId = e[0].fileId;
                this.form.model.product_clock[this.selectscope].image.filePath=e[0].filePath;
            }
            this.isProductUpload = false;
        },

        /*删除商品图片*/
        deleteImg(index) {
            this.form.model.detailimg.splice(index, 1);
        },
        delVideo() {
            this.form.model.video_id = 0;
            this.form.model.video = {};
        },
        handleClose(tagItem) {
            this.form.model.tag.splice(this.form.model.tag.indexOf(tagItem), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                if (this.form.model.tag == null) {
                    this.form.model.tag = [];
                }
                this.form.model.tag.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = "";
        }
    }
};
</script>

<style>
.edit_container {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    line-height: 20px;
    color: #2c3e50;
}

.ql-editor {
    height: 400px;
}

.draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

.img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
    width: 100px;
    height: 100px;
}

.draggable-list .img-select i {
    color: #409eff;
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}

.myborder {
    border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/clockProduct.vue